// Central content source — swap these placeholders with API data when the Phase 6 backend lands.

export const company = {
  name: "Mandair Movers General Transport L.L.C — S.P.C",
  shortName: "Mandair Movers",
  tagline: "Moving Loads. Building Trust.",
  registration: "101-2023-100151629",
  license: "CN-4895322",
  unifiedLicense: "501-2023-100228332",
  authority: "Abu Dhabi Department of Economic Development",
  established: "2023",
  experience: "20+",
  headOffice: "Abu Dhabi, UAE",
  history:
    "Mandair Movers is the advanced evolution of Al Musafah Transport — in existence from 2005 to 2022 — rebuilt into a modern, premium transport house headquartered in Abu Dhabi.",
  intro:
    "Mandair Movers General Transport L.L.C — S.P.C is a professional transportation company based in the United Arab Emirates, providing reliable, safe and efficient cargo transportation across the UAE and the entire GCC. We specialize in heavy transportation, container movement, industrial transport and project cargo handling. With a modern fleet, experienced drivers and a dedicated operations team, we ensure timely deliveries while maintaining the highest standards of safety and customer satisfaction.",
  mission:
    "To provide safe, reliable and cost-effective transportation solutions while delivering exceptional customer service and building long-term business relationships.",
  vision:
    "To become one of the leading transportation companies in the UAE and GCC by continuously improving our services, expanding our fleet and embracing modern transport technologies.",
  values: ["Safety First", "Reliability", "Customer Satisfaction", "Professionalism", "Integrity", "On-Time Delivery", "Continuous Improvement"],
  whyChooseUs: [
    "Reliable & On-Time Delivery",
    "Competitive Pricing",
    "Professional & Experienced Team",
    "Safe Handling of Cargo",
    "Strong Network Across UAE & GCC",
    "GPS-Enabled Real-Time Fleet Tracking",
  ],
};

export const heroStats = [
  { value: 20, suffix: "+", label: "Years of Experience" },
  { value: 100, suffix: "+", label: "Fleet Vehicles" },
  { value: 6, suffix: "", label: "GCC Countries" },
  { value: 5000, suffix: "+", label: "Deliveries Completed" },
];

export const timeline = [
  { year: "2005", title: "Al Musafah Transport Founded", text: "The journey begins — a small fleet, a big promise: move anything, anywhere in the Emirates, safely." },
  { year: "2022", title: "Regional Expansion", text: "Routes open across Saudi Arabia, Oman, Qatar, Kuwait and Bahrain. The fleet crosses 100 vehicles." },
  { year: "2023", title: "Mandair Movers Established", text: "Al Musafah evolves into Mandair Movers General Transport L.L.C — S.P.C, headquartered in Abu Dhabi." },
  { year: "Future", title: "GCC's Leading Carrier", text: "One goal ahead: the most trusted transportation company across the Gulf Cooperation Council." },
];

export const services = [
  { title: "Flatbed Trailer Transport", text: "Open-deck hauling for oversized loads, machinery and steel across all Emirates and borders.", image: "/assets/fleet/fleet-13.jpg" },
  { title: "Container Transportation", text: "Port-to-door container movement with precision scheduling and secure handling.", image: "/assets/fleet/fleet-01.jpg" },
  { title: "General Cargo", text: "Everyday freight moved with uncommon care — palletized, crated or loose.", image: "/assets/fleet/fleet-08.jpg" },
  { title: "Loose Cargo Delivery", text: "Flexible loose-load delivery for construction sites, warehouses and retail hubs.", image: "/assets/fleet/fleet-15.jpg" },
  { title: "A-Frame Transportation", text: "Specialized A-frame trailers for glass, marble and delicate sheet cargo.", image: "/assets/fleet/fleet-07.jpg" },
  { title: "Low Bed Trailer", text: "Heavy-haul low beds for excavators, cranes and industrial equipment up to 80 tons.", image: "/assets/fleet/fleet-09.jpg" },
  { title: "Bogie Transportation", text: "Multi-axle bogie trailers engineered for extreme weights and long distances.", image: "/assets/fleet/fleet-02.jpg" },
  { title: "Oversized Equipment", text: "Certified movement of oversized machinery with escort, permits and route planning.", image: "/assets/fleet/fleet-12.jpg" },
  { title: "Cross-Border Transport", text: "Seamless GCC border clearance — documentation, customs and convoy coordination.", image: "/assets/fleet/fleet-03.jpg" },
  { title: "Machinery Transportation", text: "Secure transportation of industrial machinery and manufacturing equipment.", image: "/assets/fleet/fleet-14.jpg" },
];

export const fleet = [
  {
    name: "Volvo FH12",
    capacity: "80 Tons",
    image: "/assets/fleet/fleet-14.jpg",
    trailers: ["Flatbed", "Container", "Low Bed"],
    specs: ["Volvo D12 · 420 HP", "6x4 Axle Configuration", "GPS Tracked 24/7", "Cross-Border Certified"],
  },
  {
    name: "Volvo FM12",
    capacity: "80 Tons",
    image: "/assets/fleet/fleet-12.jpg",
    trailers: ["Bogie", "A-Frame", "Flatbed"],
    specs: ["Volvo D12 · 380 HP", "Multi-Trailer Ready", "GPS Tracked 24/7", "Escort & Permits Included"],
  },
];

export const trailerTypes = ["Flatbed", "Container", "Low Bed", "Bogie", "A-Frame"];

export const countries = [
  { name: "UAE", detail: "All Emirates — Abu Dhabi HQ", node: [600, 330] },
  { name: "Saudi Arabia", detail: "Riyadh · Dammam · Jubail · Jeddah", node: [430, 260] },
  { name: "Oman", detail: "Muscat · Sohar · Buraimi", node: [700, 400] },
  { name: "Qatar", detail: "Entire Country", node: [572, 252] },
  { name: "Kuwait", detail: "Entire Country", node: [500, 82] },
  { name: "Bahrain", detail: "Entire Country", node: [555, 205] },
];

export const industries = [
  { name: "Steel Industry", icon: "Anvil", image: "/assets/fleet/fleet-06.jpg" },
  { name: "Oil Industry", icon: "Fuel", image: "/assets/fleet/fleet-09.jpg" },
  { name: "Construction", icon: "HardHat", image: "/assets/fleet/fleet-07.jpg" },
  { name: "Food Industry", icon: "Wheat", image: "/assets/fleet/fleet-15.jpg" },
  { name: "Paper Industry", icon: "Newspaper", image: "/assets/fleet/paper-rolls.jpg" },
  { name: "Logistics", icon: "Network", image: "/assets/fleet/fleet-01.jpg" },
];

export const stats = [
  { value: 20, suffix: "+", label: "Years Experience" },
  { value: 100, suffix: "+", label: "Fleet Vehicles" },
  { value: 200, suffix: "+", label: "Employees" },
  { value: 5000, suffix: "+", label: "Deliveries" },
];

export const galleryImages = [
  { url: "/assets/fleet/loading-01.jpg", caption: "Container Loading — Reach Stacker" },
  { url: "/assets/fleet/loading-02.jpg", caption: "Port Loading Operations" },
  { url: "/assets/fleet/fleet-01.jpg", caption: "Container Haulage — CMA CGM" },
  { url: "/assets/fleet/fleet-02.jpg", caption: "Night Fleet Lineup" },
  { url: "/assets/fleet/fleet-03.jpg", caption: "DP World Container Run" },
  { url: "/assets/fleet/fleet-06.jpg", caption: "Steel Coil Transport" },
  { url: "/assets/fleet/fleet-07.jpg", caption: "A-Frame Prefab Panels" },
  { url: "/assets/fleet/fleet-08.jpg", caption: "Curtain-Side General Cargo" },
  { url: "/assets/fleet/fleet-09.jpg", caption: "Crane Loading — Steel Pipes" },
  { url: "/assets/fleet/fleet-12.jpg", caption: "Modular Unit Transport" },
  { url: "/assets/fleet/fleet-13.jpg", caption: "Packaged Goods Flatbed" },
  { url: "/assets/fleet/fleet-14.jpg", caption: "Volvo FH13 Globetrotter" },
  { url: "/assets/fleet/fleet-15.jpg", caption: "Bulk Bags — SABIC" },
  { url: "/assets/fleet/fleet-04.jpg", caption: "Fleet Operations" },
  { url: "/assets/fleet/fleet-05.jpg", caption: "On the Road" },
  { url: "/assets/fleet/fleet-10.jpg", caption: "Heavy Haulage" },
  { url: "/assets/fleet/fleet-11.jpg", caption: "Convoy Duty" },
  { url: "/assets/fleet/fleet-16.jpg", caption: "Project Cargo" },
  { url: "/assets/fleet/fleet-17.jpg", caption: "Loading Operations" },
  { url: "/assets/fleet/fleet-18.jpg", caption: "GCC Long Haul" },
];

export const testimonials = [
  { name: "AJ STEEL", role: "Steel Manufacturer · Abu Dhabi", text: "We ship steel pipes and sections across the UAE with Mandair every week. Flatbeds arrive on time, loads properly strapped and sheeted — zero damage claims in over a year." },
  { name: "Al Ghurair Iron & Steel LLC", role: "Steel Fabricator · Abu Dhabi", text: "From our Abu Dhabi facility to project sites across the Gulf, Mandair handles our fabricated steel with real professionalism. Their drivers genuinely understand steel cargo." },
  { name: "Arabian Gulf Steel Industries — AGSI", role: "Steel Production · Abu Dhabi", text: "Moving thousands of tons of rebar and structural steel demands discipline. Mandair's fleet delivers on schedule, every single week, without excuses." },
  { name: "United Iron and Steel Company LLC", role: "Steel Manufacturer · UAE", text: "Reliable flatbed capacity whenever we call — Mandair has become an extension of our own dispatch team. Coordination is smooth and paperwork is always in order." },
  { name: "Noatum Logistics", role: "Warehousing & Logistics · Abu Dhabi", text: "Mandair supports our Abu Dhabi warehousing operations with dependable container and flatbed movements. A professional team that communicates at every step." },
];

export const contact = {
  person: "Gurjot Singh (PRO)",
  phone: "+971 54 585 2820",
  whatsapp: "971551181584",
  whatsappDisplay: "+971 55 118 1584",
  email: "info@mandairmovers.com",
  hours: "Sat – Thu · 8:00 AM – 6:00 PM",
  hoursNote: "Emergency support available upon request",
  office: "Mafraq Industrial Area, Abu Dhabi, UAE",
};

export const socials = {
  linkedin: "https://www.linkedin.com",
  instagram: "https://www.instagram.com/mandairmovers_llc?igsh=NXp4YzNrbW9iMGkw",
  facebook: "https://www.facebook.com/share/1Fqk2WARkN/",
  tiktok: "https://www.tiktok.com/@mandair141?_r=1&_t=ZS-98ewuM81RKO",
  twitter: "",
  youtube: "",
};

export const siteSettings = {
  profile_pdf: "/assets/Mandair-Movers-Company-Profile.pdf",
};

export const openings = [
  { title: "Heavy Truck Driver — Volvo FH/FM", location: "Abu Dhabi, UAE", type: "Full-time", requirement: "3+ years GCC heavy-trailer experience, valid UAE heavy vehicle license" },
  { title: "Trailer Driver — Flatbed / Low Bed", location: "Abu Dhabi, UAE", type: "Full-time", requirement: "2+ years flatbed or low-bed experience, cross-border knowledge preferred" },
  { title: "Operations Coordinator", location: "Abu Dhabi, UAE", type: "Full-time", requirement: "Transport operations background, strong communication in English & Hindi/Arabic" },
];

export const images = {
  heroBg: "/assets/fleet/fleet-02.jpg",
  industryFactory: "/assets/fleet/fleet-09.jpg",
  industrySteel: "/assets/fleet/fleet-06.jpg",
};
